import { useQuery } from '@zg-rentals/react-query5';

import { ExternalTourProviders } from '../../model/ExternalTourProviders';

import { RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders } from '@zg-rentals/rental-manager-env';

const useGetExternalTourProviders = (queryOptions = {}) => {
  const queryHook = useQuery({
    queryKey: ['useGetExternalTourProviders'],
    queryFn: async () => {
      const data = await RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders();
      const sortedData = data.sort((a, b) => a.localeCompare(b));
      return ExternalTourProviders(sortedData);
    },
    ...queryOptions,
    enabled: true,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return queryHook;
};

export { useGetExternalTourProviders };
